import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";

function Authentication({ log }: Props) {
  const { t } = useTranslation();

  return (
    <div>
      <p>
        {t(
          `planzoneLogsPage.description.${log.content}.${log.attributes.target}`,
        )}
      </p>
    </div>
  );
}

export { Authentication };
